<script>
	import { Bar } from 'vue-chartjs'
	import ChartDataLabels from 'chartjs-plugin-datalabels';
	export default {
		extends: Bar,
		props: ['cData', 'cOptions'],
		mounted () {
			this.renderChart(this.cData, this.cOptions)
		}
	}
</script>
